import { j as i, a as o } from "../../../../../emotion-react-jsx-runtime.browser.esm-CsRinUqv.js";
import { translate as l } from "../../../../string-table.js";
import { Colors as p } from "../../../../1-foundations/Colors/Colors.js";
import { I as r } from "../../../../../Icon-IZV2yalv.js";
import { I as u } from "../../../../../FeatureFlagProvider-C_WBizLB.js";
import "react";
import "@ionic/react";
import "../../../../../react-paginate-Lh5zQzpz.js";
import { Section as f } from "../Section/Section.js";
import "../../../LoadingInterstitial/LoadingInterstitial.js";
import "../../../../contexts/DesignSystemProvider/DesignSystemProvider.js";
import '../../../../../css/ClassroomPreferences.css';const L = "_container_1i3rl_1", h = {
  container: L,
  "content-title": "_content-title_1i3rl_9",
  "content-no-info": "_content-no-info_1i3rl_13"
}, c = {
  datomic: {
    ece: "pre-k,tk",
    "k-2": "k,1,2",
    "3-5": "3,4,5",
    "6-8": "6,7,8",
    "9-12": "9,10,11,12"
  },
  valueTypes: {
    "pre-k": "ece",
    tk: "ece",
    k: "k-2",
    1: "k-2",
    2: "k-2",
    3: "3-5",
    4: "3-5",
    5: "3-5",
    6: "6-8",
    7: "6-8",
    8: "6-8",
    9: "9-12",
    10: "9-12",
    11: "9-12",
    12: "9-12"
  },
  display: {
    ece: "Early Childhood Education (Pre-K and TK)",
    "pre-k": "Early Childhood Education (Pre-K and TK)",
    tk: "Early Childhood Education (Pre-K and TK)",
    k: "K to 2nd",
    1: "K to 2nd",
    2: "K to 2nd",
    3: "3rd to 5th",
    4: "3rd to 5th",
    5: "3rd to 5th",
    6: "6th to 8th",
    7: "6th to 8th",
    8: "6th to 8th",
    9: "9th to 12th",
    10: "9th to 12th",
    11: "9th to 12th",
    12: "9th to 12th"
  }
}, O = {
  "gen-ed": "General Education",
  elective: "Electives (Music, Art, etc.)",
  english: "English/Language Arts",
  "physical-education": "Health/Physical Education",
  "social-studies": "History/Social Studies",
  math: "Math",
  science: "Science",
  "special-education": "Special Education",
  "world-languages": "World Languages",
  other: "Other",
  "not-sure": "I'm not sure yet"
}, k = {
  english: "English",
  spanish: "Spanish",
  mandarin: "Chinese (Mandarin)",
  cantonese: "Chinese (Cantonese)",
  french: "French",
  tagalog: "Tagalog",
  vietnamese: "Vietnamese",
  arabic: "Arabic",
  korean: "Korean",
  japanese: "Japanese",
  german: "German",
  asl: "American Sign Language",
  other: "Other"
};
function g(n, e) {
  if (!n || n.length === 0) return;
  const t = Array.from(new Set(n.map((a) => e[a])));
  if (e === c.display)
    return t.sort((a, d) => _(a) - _(d));
  const s = Object.values(e).reduce((a, d, S) => (a[d] = S, a), {});
  return t.sort((a, d) => s[a] - s[d]);
}
function M(n, e) {
  return e === c.datomic ? n.map((t) => e[t]) : JSON.parse(n).map((t) => t);
}
function P(n) {
  var E, s, a;
  const {
    editable: e,
    classroomPreferences: t
  } = n;
  return /* @__PURE__ */ i(f, {
    title: l("SUB_PROFILE_CLASSROOM_PREFERENCES_HEADER"),
    children: /* @__PURE__ */ o("div", {
      className: h.container,
      children: [/* @__PURE__ */ i(u, {
        content: /* @__PURE__ */ o("div", {
          children: [/* @__PURE__ */ o("span", {
            className: h["content-title"],
            children: [l("SUB_PROFILE_CLASSROOM_PREFERENCES_LABEL_GRADE_LEVEL"), ":", " "]
          }), m(g((E = t == null ? void 0 : t.gradeLevels) == null ? void 0 : E.value, c.display))]
        }),
        leftIcon: /* @__PURE__ */ i(r, {
          name: "Grad Cap"
        }),
        ...e != null && e.isEditable ? {
          rightIcon: {
            icon: /* @__PURE__ */ i(r, {
              name: "Edit",
              color: p.blue500
            }),
            onClick: e.onEditGradeLevel
          }
        } : {}
      }), /* @__PURE__ */ i(u, {
        content: /* @__PURE__ */ o("div", {
          children: [/* @__PURE__ */ o("span", {
            className: h["content-title"],
            children: [l("SUB_PROFILE_CLASSROOM_PREFERENCES_LABEL_SUBJECTS"), ":", " "]
          }), m(g((s = t == null ? void 0 : t.subjects) == null ? void 0 : s.value, O))]
        }),
        leftIcon: /* @__PURE__ */ i(r, {
          name: "Book"
        }),
        ...e != null && e.isEditable ? {
          rightIcon: {
            icon: /* @__PURE__ */ i(r, {
              name: "Edit",
              color: p.blue500
            }),
            onClick: e.onEditSubjects
          }
        } : {}
      }), /* @__PURE__ */ i(u, {
        content: /* @__PURE__ */ o("div", {
          children: [/* @__PURE__ */ o("span", {
            className: h["content-title"],
            children: [l("SUB_PROFILE_CLASSROOM_PREFERENCES_LABEL_LANGUAGES"), ":", " "]
          }), m(g((a = t == null ? void 0 : t.languages) == null ? void 0 : a.value, k))]
        }),
        leftIcon: /* @__PURE__ */ i(r, {
          name: "Chat Bubble Active"
        }),
        ...e != null && e.isEditable ? {
          rightIcon: {
            icon: /* @__PURE__ */ i(r, {
              name: "Edit",
              color: p.blue500
            }),
            onClick: e.onEditLanguages
          }
        } : {}
      })]
    })
  });
}
function m(n) {
  return n ? /* @__PURE__ */ i("span", {
    children: n.join(", ")
  }) : /* @__PURE__ */ i("span", {
    className: h["content-no-info"],
    children: l("SUB_PROFILE_NO_INFORMATION")
  });
}
function _(n) {
  return Object.keys(c.display).indexOf(Object.keys(c.display).find((t) => c.display[t] === n) ?? "");
}
export {
  P as ClassroomPreferences,
  g as convertPreferencesToDisplay,
  M as convertPreferencesToSave,
  _ as getGradeLevelIndex,
  c as gradeLevelMappings,
  k as languageMapper,
  O as subjectMapper
};
